module.exports = __webpack_public_path__ + "static/img/5.cee69cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/5.png
// module id = 7INO
// module chunks = 35